<app-home-hero-section></app-home-hero-section>

<app-home-proof-strip></app-home-proof-strip>

<app-home-how-it-works-section></app-home-how-it-works-section>

<div class="bg-white py-20 md:py-24 grid grid-cols-12">
  <div class="col-span-12 px-4 md:col-start-2 md:col-span-10 md:px-0">
    <p class="text-center justify-center text-gray-900 text-4xl font-extrabold font-['Inter'] leading-tight">
      Imóveis em destaque no momento
    </p>
    <div class="mt-3 text-center justify-center text-gray-500 text-lg sm:text-xl font-normal font-['Inter'] leading-relaxed">
      Conheça os imóveis que receberam lances na última semana e estão no centro das atenções
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 gap-5 mt-10">
      @for (realEstate of realEstates.slice(0, 6); track realEstate.link; ) {
        <app-real-estate-card [realEstate]="realEstate"></app-real-estate-card>
      }
    </div>
  </div>
</div>

<app-home-analysis-section></app-home-analysis-section>

<app-home-alerts-section></app-home-alerts-section>

<section class="border-y border-slate-100 bg-[#F7F9FF] py-24 md:py-28">
  <div class="mx-auto max-w-7xl px-4 sm:px-5 md:px-0">
    <div class="mx-auto max-w-4xl text-center">
      <h2 class="text-center text-gray-900 text-4xl font-semibold tracking-[-0.03em] font-['Inter'] leading-tight md:text-5xl">
        Fontes monitoradas
      </h2>
      <p class="mt-5 text-center text-slate-500 text-lg sm:text-xl font-normal font-['Inter'] leading-relaxed">
        Casato Brasil consolida e organiza informações de imóveis disponibilizados em fontes públicas e plataformas de leilão de terceiros, incluindo instituições financeiras, leiloeiros e portais especializados.
      </p>
    </div>

    <div class="mx-auto mt-12 grid max-w-4xl grid-cols-1 gap-4 md:grid-cols-3 xl:gap-6">
      <a
        href="https://www.caixa.gov.br/voce/habitacao/imoveis-venda/Paginas/default.aspx"
        target="_blank"
        rel="noopener noreferrer"
        class="flex min-h-[96px] items-center justify-center rounded-[1.5rem] border border-blue-100 bg-[#F4F7FF] px-5 py-4 text-center shadow-[0px_1px_2px_-1px_rgba(37,99,235,0.10)] shadow-[0px_8px_24px_rgba(37,99,235,0.08)] transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#EEF3FF] focus:outline-none focus:ring-4 focus:ring-blue-200">
        <span class="text-xl font-semibold tracking-[-0.02em] text-blue-700 font-['Inter']">Caixa</span>
      </a>
      <a
        href="https://www.portalzuk.com.br/"
        target="_blank"
        rel="noopener noreferrer"
        class="flex min-h-[96px] items-center justify-center rounded-[1.5rem] border border-blue-100 bg-[#F4F7FF] px-5 py-4 text-center shadow-[0px_1px_2px_-1px_rgba(37,99,235,0.10)] shadow-[0px_8px_24px_rgba(37,99,235,0.08)] transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#EEF3FF] focus:outline-none focus:ring-4 focus:ring-blue-200">
        <span class="text-xl font-semibold tracking-[-0.02em] text-blue-700 font-['Inter']">Portal Zuk</span>
      </a>
      <a
        href="https://alfaleiloes.com"
        target="_blank"
        rel="noopener noreferrer"
        class="flex min-h-[96px] items-center justify-center rounded-[1.5rem] border border-blue-100 bg-[#F4F7FF] px-5 py-4 text-center shadow-[0px_1px_2px_-1px_rgba(37,99,235,0.10)] shadow-[0px_8px_24px_rgba(37,99,235,0.08)] transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#EEF3FF] focus:outline-none focus:ring-4 focus:ring-blue-200">
        <span class="text-xl font-semibold tracking-[-0.02em] text-blue-700 font-['Inter']">Alfa Leilões</span>
      </a>
    </div>

    <div class="mx-auto mt-12 max-w-5xl px-1 text-center md:px-2">
      <p class="text-[1.05rem] font-normal leading-[1.8] text-slate-500 font-['Inter']">
        Os nomes e marcas eventualmente mencionados pertencem aos seus respectivos titulares e são utilizados exclusivamente para fins informativos e de identificação da origem dos dados. A Casato Brasil não representa, possui vínculo, parceria oficial, autorização comercial ou afiliação com tais empresas, salvo quando expressamente indicado.
      </p>
      <p class="mt-6 text-[1.05rem] font-normal leading-[1.8] text-slate-500 font-['Inter']">
        As informações exibidas na plataforma possuem caráter informativo e estimativo, podendo sofrer alterações sem aviso prévio diretamente nas fontes originais.
      </p>
    </div>
  </div>
</section>

<app-home-final-cta-section></app-home-final-cta-section>
